import React, { useState, useEffect, Fragment } from "react";

import {
  Form,
  Input,
  Button,
  Popconfirm,
  message,
  Table,
  Tag,
  Select,
  Space,
} from "antd";

import {
  DeleteFilled,
  PlusCircleFilled,
  FontSizeOutlined,
} from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./MediaList.module.less";

const { Option } = Select;

function MediaList({ location, navigate }) {
  const { state } = location;

  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [data, setData] = useState({});
  const [search, setSearch] = useState(state?.search ? state.search : {});
  const [pagination, setPagination] = useState(
    state?.pagination
      ? state.pagination
      : {
          current: 1,
          pageSize: 10,
          total: 0,
        }
  );

  const [brands, setBrands] = useState([]);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  const [form] = Form.useForm();

  const columns = [
    {
      title: "编号",
      dataIndex: "id",
      key: "id",
      ellipsis: true,
      width: 120,
    },
    {
      title: "标题",
      dataIndex: "title",
      key: "title",
      ellipsis: true,
      render: (value, data) => (
        <a
          onClick={() => {
            if (data.status === 0) {
              getTitle(data.id);
            } else {
              message.warning("已获取，请勿重复获取！");
            }
          }}
        >
          {value}
        </a>
      ),
    },
    {
      title: "品牌",
      dataIndex: ["brand", "name"],
      key: ["brand", "name"],
      ellipsis: true,
      width: 140,
    },
    {
      title: "类型",
      dataIndex: "type",
      key: "type",
      ellipsis: true,
      width: 120,
      render: (value) => {
        if (value === 1) return <Tag color="cyan">新闻</Tag>;
        if (value === 2) return <Tag color="blue">贴吧</Tag>;
        if (value === 3) return <Tag color="orange">知道</Tag>;
        return null;
      },
    },
    {
      title: "收录",
      dataIndex: "included",
      key: "included",
      ellipsis: true,
      width: 240,
      render: (_, data) => {
        return (
          <Fragment>
            <Tag
              style={{
                color: data.baidu !== 0 ? null : "#999",
              }}
              color={data.baidu !== 0 ? "#108ee9" : null}
              title={data.baidu !== 0 ? "已收录" : "未收录"}
            >
              百度
            </Tag>
            <Tag
              style={{
                color: data.so !== 0 ? null : "#999",
              }}
              color={data.so !== 0 ? "#87d068" : null}
              title={data.so !== 0 ? "已收录" : "未收录"}
            >
              360
            </Tag>
            <Tag
              style={{
                color: data.sogou !== 0 ? null : "#999",
              }}
              color={data.sogou !== 0 ? "#2db7f5" : null}
              title={data.sogou !== 0 ? "已收录" : "未收录"}
            >
              搜狗
            </Tag>
            <Tag
              style={{
                color: data.sm !== 0 ? null : "#999",
              }}
              color={data.sm !== 0 ? "#f50" : null}
              title={data.sm !== 0 ? "已收录" : "未收录"}
            >
              神马
            </Tag>
          </Fragment>
        );
      },
    },
    {
      title: "时间",
      dataIndex: "createdTime",
      key: "createdTime",
      ellipsis: true,
      width: 200,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      width: 180,
      render: (_, data) => (
        <Fragment>
          <Button type="link" size="small" href={data.url} target="_blank">
            链接
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              navigate(`save`, { state: { data, search, pagination } });
            }}
          >
            编辑
          </Button>
          <Popconfirm title="是否确认删除?" onConfirm={() => onDelete(data.id)}>
            <Button type="link" size="small">
              删除
            </Button>
          </Popconfirm>
        </Fragment>
      ),
    },
  ];

  const onSearch = (values) => {
    if (values.kw) {
      values.kw = values.kw.replace(/\s+/g, "");
    }
    setSearch(values);
    onLoading({
      search: values,
      pagination: { current: 1, pageSize: 10, total: 0 },
    });
  };

  const onDelete = async (id) => {
    let para = queryString.stringify({ id });
    try {
      let parsed = await Http.post(`media/delete`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onLoading({ search, pagination });
        setSelected([]);
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const getTitle = async (id) => {
    let values = [];
    if (typeof id === "number") {
      values = [id];
    } else {
      for (let i = 0; i < id.length; i++) {
        data.list.forEach((val) => {
          if (val.id === id[i]) {
            if (val.status === 0) {
              values.push(id[i]);
            }
          }
        });
      }
    }
    let para = queryString.stringify({ id: values });
    try {
      let parsed = await Http.post(`media/parse`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onLoading({ search, pagination });
        setSelected([]);
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const getBrandList = async (params) => {
    try {
      let para = queryString.stringify({
        pageNumber: params.brandPagination.current,
        pageSize: params.brandPagination.pageSize,
      });
      let parsed = await Http.get(`brand`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        setBrands([...brands, ...parsed.result.list]);
        setBrandPagination({
          current: parsed.result.pageNumber,
          pageSize: parsed.result.pageSize,
          total: parsed.result.totalRow,
        });
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const getMediaList = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`media`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setData(parsed.result);
      setPagination({
        current: parsed.result.pageNumber,
        pageSize: parsed.result.pageSize,
        total: parsed.result.totalRow,
      });
    }
  };

  const onLoading = async (params) => {
    setLoading(true);
    try {
      await getMediaList({
        ...params.search,
        pageNumber: params.pagination.current,
        pageSize: params.pagination.pageSize,
      });
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBrandList({ brandPagination });
    onLoading({ search, pagination });
  }, []);

  return (
    <div className={styles.MediaList}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {selected.length > 0 ? (
            <Space>
              <Popconfirm
                title="是否确认删除?"
                onConfirm={() => {
                  onDelete(selected);
                }}
              >
                <Button type="primary" danger icon={<DeleteFilled />}>
                  删除
                </Button>
              </Popconfirm>
              <Button
                type="primary"
                icon={<FontSizeOutlined />}
                onClick={() => getTitle(selected)}
              >
                获取标题
              </Button>
            </Space>
          ) : (
            <Button
              type="primary"
              icon={<PlusCircleFilled />}
              onClick={() => navigate(`save`)}
            >
              新增
            </Button>
          )}
        </div>
        <div className={styles.headerRight}>
          <Form
            form={form}
            layout="inline"
            initialValues={search}
            onFinish={onSearch}
          >
            <Form.Item name="url" style={{ width: 240 }}>
              <Input placeholder="请输入链接" />
            </Form.Item>
            <Form.Item name="brandId">
              <Select
                showSearch
                placeholder="请选择品牌"
                style={{ width: 160 }}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {brands.map((value) => (
                  <Option value={value.id} key={value.id}>
                    {value.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="type">
              <Select
                placeholder="请选择类型"
                style={{ width: 120 }}
                allowClear
              >
                <Option value={1}>新闻</Option>
                <Option value={2}>贴吧</Option>
                <Option value={3}>知道</Option>
              </Select>
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="reset"
                onClick={() => {
                  form.resetFields();
                }}
              >
                重置
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className={styles.content}>
        <Table
          loading={loading}
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            onChange: (srk) => {
              setSelected(srk);
            },
          }}
          onChange={(p, f, s) => {
            let sort = null;
            if (s.order) {
              sort = `${s.field} ${s.order.replace("end", "")}`;
            }
            onLoading({ search: { ...search, sort }, pagination: p });
          }}
          dataSource={data.list}
          columns={columns}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showTotal: () => {
              return `总共 ${pagination.total} 条数据`;
            },
          }}
        />
      </div>
    </div>
  );
}

export default MediaList;
